import {Component, inject, model, OnInit, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  BusinessType,
  BusinessTypeArray,
  Page,
  UserOfficialDto,
  UserOfficialSearchParams
} from "../../../generated-model/model";
import {DecimalPipe, NgForOf, NgIf} from '@angular/common';
import {NgbActiveModal, NgbModal, NgbPagination} from '@ng-bootstrap/ng-bootstrap';
import {NotFoundComponent} from '../../shared/not-found/not-found.component';
import {AsyncLoadingComponent} from '../../shared/async-loading/async-loading.component';
import {HasAnyRoleDirective} from '../../auth/has-any-role.directive';
import {RoleService} from '../../shared/commons/services/role.service';
import {ToastService} from '../../shared/commons/toast/toast-service';
import {filter} from 'rxjs/operators';
import {from} from 'rxjs';
import {ManageOfficialUserModalComponent} from './manage-official-user-modal/manage-official-user-modal.component';
import {IgnoreNullHttpParams} from '../../shared/Ignore-null-http-params';
import {UserRest} from '../../service/UserRest';
import {
  ManageAddOfficialUserModalComponent
} from './manage-add-official-user-modal/manage-add-official-user-modal.component';
import {SsoUser} from '../../app.constants';
import {UserService} from '../../shared/commons/services/user.service';

@Component({
  selector: 'app-manage-user-official',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DecimalPipe,
    NgForOf,
    NgIf,
    NgbPagination,
    AsyncLoadingComponent,
    NotFoundComponent,
    HasAnyRoleDirective,
    FormsModule
  ],
  templateUrl: './manage-official-user.component.html',
  styleUrl: './manage-official-user.component.scss'
})
export class ManageOfficialUserComponent implements OnInit {

  pageData = signal<Page<UserOfficialDto>>({number: 1, size: 10});
  isLoading = false;
  private modalService = inject(NgbModal);
  roleService = inject(RoleService)
  toastService = inject(ToastService)
  params = signal<UserOfficialSearchParams>({admin:null,userType:null,enable:null})
  userService = inject(UserRest)
  userDataService=inject(UserService)
  userData = signal<SsoUser>(undefined)

  ngOnInit() {
    this.userDataService.getUser().subscribe({
      next: (userData: SsoUser | null) => {
        this.userData.set(userData);
      }
    })
    this.search()
    console.log(this.userData())
  }

  clear(){
    this.params.set({userType:null,enable:null})
    this.search();
  }

  search(number = 1) {
    this.isLoading = true;
    const pageRequest = {page:number - 1, size:this.pageData().size, sort:'createdDate,desc'}
    const params = IgnoreNullHttpParams.fromObject({...this.params()})
      .set("page", pageRequest.page)
      .set("size", pageRequest.size)
      .set("sort", pageRequest.sort)
    this.userService.searchOfficialUser(params).subscribe({
      next:data=>{
        this.pageData.set(data)
      }, error:(e)=>{
        console.log(e)
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  openModel(prefix: string,item:UserOfficialDto) {
    if (prefix === 'เพิ่ม') {
      const modalRef = this.modalService.open(ManageAddOfficialUserModalComponent, {
        size: 'xl'
      });
      modalRef.componentInstance.prefix = prefix + 'เจ้าหน้าที่'
      modalRef.componentInstance.userData=this.userData()
      from(modalRef.result).pipe(filter(e => !!e))
        .subscribe(e => {
          this.search()
        });
    }
    else if(prefix === 'แก้ไข'){
      const modalRef = this.modalService.open(ManageOfficialUserModalComponent, {
        size: 'xl'
      });
      if(this.userData().sub === item.ssoUserId){
        modalRef.componentInstance.disable=signal(false);
      }
      else{
        modalRef.componentInstance.disable=signal(true);
      }
      modalRef.componentInstance.prefix = prefix + 'รายละเอียดเจ้าหน้าที่'
      modalRef.componentInstance.userOfficialDto = signal<UserOfficialDto>({...item})
      modalRef.componentInstance.userData.set(this.userData())
      from(modalRef.result).pipe(filter(e => !!e))
        .subscribe(e=>{
          this.search()
        })
    }

  }
}
